<template>
    <Head title="ユーザー一覧" />

    <BreezeAuthenticatedLayout>
      <main class="container">
        <AdminNav />
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

              <div class="flex justify-end m-2 p-2">
                <!-- <Link href="/users/create" class="px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded">ユーザーを追加</Link> -->
              </div>

              <!-- This example requires Tailwind CSS v2.0+ -->
              <div class="flex flex-col">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                          <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>

                            <th scope="col" class="relative px-6 py-3">
                              <!-- <span class="sr-only">Edit</span> -->
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="user in users" :key="user.id">
                            <td class="px-6 py-4 whitespace-nowrap">
                              <Link :href="`/users/${user.id}`">{{ user.name }}</Link>
                            </td>

                          
                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-4">
                              <!-- <Link :href="`/users/${user.id}`" class="text-indigo-600 hov7er:text-indigo-900">詳細</Link>

                              <Link :href="`/users/edit`" class="text-indigo-600 hover:text-indigo-900">編集</Link> -->

                              <!--
                              <Link @click="destroy(user.id)" class="text-red-700">削除
                              </Link >
                              -->
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import Side from '@/Shared/Side'
import AdminNav from '@/Shared/AdminNav'

export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    Side,
    AdminNav
  },
  props: {
    users: Array
  },
  methods: {
    destroy(id) {
        if (confirm('本当に削除しますか？')) {
            this.$inertia.delete(route("users.destroy", id));
        }
    },
  },
}

</script>
